import React from 'react'

import poweredByTw from '@frame/images/powered-by-tw.svg'
import { DataAttribute } from '@frame/types'

export function PoweredByTruework() {
  return (
    <img
      aria-label="Powered by Truework"
      role="img"
      data-cy={DataAttribute.POWERED_BY_TRUEWORK}
      src={poweredByTw}
      className="mx-auto"
    />
  )
}
